import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ComboParticipanteReuniao } from 'src/app/core/combo-participante-reuniao';
import { ParticipanteReuniaoService } from '../../../services/participante-reuniao/participante-reuniao.service';
@Component({
  selector: 'combo-pesquisa-participante-reuniao',
  templateUrl: './combo-pesquisa-participante-reuniao.component.html',
  styleUrls: ['./combo-pesquisa-participante-reuniao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboPesquisaParticipanteReuniaoComponent implements OnInit {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label;
  @Input() campoPesquisavel = 'nome';
  @Input() fxFlexOffset = "20px";

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};
  
  constructor(private participanteReuniaoService: ParticipanteReuniaoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    setTimeout(() => {
      let $_evento;
      
      $_evento = this.participanteReuniaoService.getAllParticipantesCombo();  

      $_evento.subscribe((reunioes: ComboParticipanteReuniao[]) => {
        this.dados = reunioes;
        this.preencherCombo();

        this.dados.forEach(a => {
          a.nome = a.nome;
        } );

        
        this.dados.sort((a, b) => {
          if (a.nome > b.nome) { return 1; }
          return 0;
        });
      });

    }, 0);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
      this.preencherCombo();
    }
  }

  private preencherCombo() {
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }
}
